import { AbstractControl } from "@angular/forms";

export function firmIdValidator(control: AbstractControl) {
    const value: string = control.value.toString();
    if (!value.toLowerCase().startsWith('tx') || isNaN(parseInt(value.substring(2)))) {
      return { invalid: true };
    }
    return null;
}